export const UNDERWEIGHT_THRESHOLD = 18.5;
